module.exports = __webpack_public_path__ + "media/audio.c33077c1.ogg";